import Link from "next/link";
import type { ReactNode } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


interface SocialSignInProps {
    className?: string;
    provider: string;
    redirectPathname: string | null;
    children: ReactNode;
}


export function SocialSignIn({
    className, provider, redirectPathname, children,
}: SocialSignInProps) {
    const urlParams = new URLSearchParams();
    urlParams.set("provider", provider);
    if (redirectPathname) {
        urlParams.set("redirect", redirectPathname);
    }
    return (
        <Link
            className={cn(
                "flex w-full flex-row items-center justify-start rounded-lg border px-6 py-3 text-base shadow-sm hover:no-underline",
                className ?? null,
            )}
            prefetch={false}
            href={`/login/rosette?${urlParams.toString()}`}>

            {children}
        </Link>
    );
}
